(function () {
  function init() {
    var root = document.querySelector('[data-venture-popup]');
    if (!root) return;

    var overlay = root.querySelector('[data-venture-popup-overlay]');
    if (!overlay) return;

    var STORAGE_KEY = 'venturePopupDismissedAt';
    var scrollY = 0;

    function lockScroll() {
      scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.width = '100%';
    }

    function unlockScroll() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollY);
    }

    function show() {
      overlay.hidden = false;
      lockScroll();
      var closeBtn = overlay.querySelector('.v-popup-close');
      if (closeBtn) closeBtn.focus();
    }

    function dismiss() {
      overlay.hidden = true;
      unlockScroll();
      try {
        localStorage.setItem(STORAGE_KEY, String(Date.now()));
      } catch (e) {}
    }

    overlay.querySelectorAll('[data-venture-popup-close]').forEach(function (el) {
      el.addEventListener('click', dismiss);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) dismiss();
    });

    // If the customer form just posted successfully (page reload after
    // submit), show the success state immediately and never bother them
    // again — no need to wait for the delay or check the dismiss window.
    if (overlay.querySelector('.v-popup-success')) {
      show();
      try {
        localStorage.setItem(STORAGE_KEY, String(Date.now()));
      } catch (e) {}
      return;
    }

    var dismissDays = parseFloat(root.getAttribute('data-dismiss-days')) || 7;
    var delaySeconds = parseFloat(root.getAttribute('data-delay')) || 5;

    var dismissedAt = null;
    try {
      dismissedAt = localStorage.getItem(STORAGE_KEY);
    } catch (e) {}

    if (dismissedAt) {
      var elapsedMs = Date.now() - parseInt(dismissedAt, 10);
      if (elapsedMs < dismissDays * 24 * 60 * 60 * 1000) return;
    }

    setTimeout(show, delaySeconds * 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
